import React, { createContext, useState, useEffect } from "react";
import { db } from "../firebase/firebase"; // Firestore config
import { collection, onSnapshot } from "firebase/firestore";

// Context create karo
export const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [headerText, setHeaderText] = useState("");

  useEffect(() => {
    // Check if header text is already cached in localStorage
    const cachedHeaderText = localStorage.getItem("cachedHeaderText");
    if (cachedHeaderText) {
      setHeaderText(cachedHeaderText); // Use cached data
    }

    // Fetch fresh data from Firestore
    const unsubscribe = onSnapshot(collection(db, "header"), (snapshot) => {
      const headerData = snapshot.docs.map((doc) => doc.data().text)[0]; // First document ka text field
      setHeaderText(headerData);

      // Cache the header text in localStorage
      localStorage.setItem("cachedHeaderText", headerData);
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, []);

  return (
    <HeaderContext.Provider value={headerText}>
      {children}
    </HeaderContext.Provider>
  );
};